import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export type XpToggleValue = string | number;

export interface XpToggleOption {
	label: string;
	value: XpToggleValue;
}

@Component({
	selector: 'xp-toggle-buttons',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './xp-toggle-buttons.component.html',
	styleUrls: ['./xp-toggle-buttons.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpToggleButtonsComponent {
	options = input<XpToggleOption[]>([]);
	selected = input<XpToggleValue[]>([]);
	toggled = output<XpToggleValue>();

	isSelected(value: XpToggleValue): boolean {
		return this.selected().includes(value);
	}
}
